export default "__VITE_ASSET__Ck1Vpk77__"